export const DELETE_INDEX_WORKER_NAME = "delete_index_worker" as const;

export const DELETE_INDEX_WORKER_DESC = `Deletes an Index Worker job via the GraphQL deleteIndexWorker mutation.

Use for deleting an Index Worker job (job definition/configuration) inside an IW project.
This tool is the default for ambiguous phrases like "delete IW" or "delete Index Worker".
Use delete_project only when the user explicitly requests deleting the entire IW project.
Final user approval is handled by the confirmation UI.

Input:
- 'indexWorkerId' (required): GraphQL global ID of the Index Worker to delete.

Output:
- Returns the deleted Index Worker id, last known metadata (name/note), and helper navigation info
  (workspace/project ids and paths) when derivable from the id.

Notes:
- Write operation; always run through confirmation UI.`;
